var FormsApiService = function (jsonrpc) {
    var service = jsonrpc.newService('forms');
    this.get = service.createMethod('get');
    this.get_schema = service.createMethod('get_schema');
    this.get_model = service.createMethod('get_model');
    this.get_form = service.createMethod('get_form');
    this.submit = service.createMethod('submit');
    this.validate_prop = service.createMethod('validate_prop');
};
FormsApiService.$inject = ['jsonrpc'];


export default function(app){
    app.service('FormsApiService', FormsApiService)
};
